import SERVICE_TYPES from './serviceTypes';

const SERVICE_CODES = {
  [SERVICE_TYPES.CHECKIN]           : 'CH',
  [SERVICE_TYPES.TRANSFER]          : 'T',
  [SERVICE_TYPES.CITY_DELIVERY]     : 'CD',
  [SERVICE_TYPES.SKIP_BAGGAGE_CLAIM]: 'SBC',
  [SERVICE_TYPES.STORAGE]           : 'ST',
  [SERVICE_TYPES.LOST_AND_FOUND]    : 'LAF',
} as const;

export type ServiceCodes = typeof SERVICE_CODES;

export default SERVICE_CODES;
